import type { IncomingMessage } from 'node:http'

export function getBaseUrl(req: IncomingMessage) {
    // Always fallback to BASE_URL env variable on production
    if (process.env.APP_ENV === 'production' && process.env.BASE_URL) {
        return new URL(process.env.BASE_URL)
    }
    // Derive host and protocol from host header
    let host = req.headers.host || 'localhost:3000'
    let protocol = host.includes('localhost') ? 'http' : 'https'

    // Respect some common headers set in a behind a reverse proxy situation
    // @see: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Forwarded-Host
    if (req.headers['x-forwarded-host'] && typeof req.headers['x-forwarded-host'] === 'string') {
        host = req.headers['x-forwarded-host']
    }

    // @see: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Forwarded-Proto
    if (req.headers['x-forwarded-proto'] && typeof req.headers['x-forwarded-proto'] === 'string') {
        protocol = req.headers['x-forwarded-proto']
    }

    return new URL(`${protocol}://${host}`)
}
